// @wc-ignore-file
import { queryOptions } from "@tanstack/react-query";
import { listContainerAccess } from "./container-access-api";

export const containerAccessQueries = {
  all: () => ["container-access"] as const,
  /**
   * The caller's own access rows. Keyed by user id so a sign-in as somebody
   * else cannot read the previous user's recency out of the cache.
   */
  byUser: (userId: string) =>
    queryOptions({
      queryKey: [...containerAccessQueries.all(), userId] as const,
      queryFn: () => listContainerAccess(userId),
    }),
};
